import { render, staticRenderFns } from "./setDimensional-editor.vue?vue&type=template&id=3fe04c0e&scoped=true"
import script from "./setDimensional-editor.vue?vue&type=script&lang=js"
export * from "./setDimensional-editor.vue?vue&type=script&lang=js"
import style0 from "./setDimensional-editor.vue?vue&type=style&index=0&id=3fe04c0e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe04c0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe04c0e')) {
      api.createRecord('3fe04c0e', component.options)
    } else {
      api.reload('3fe04c0e', component.options)
    }
    module.hot.accept("./setDimensional-editor.vue?vue&type=template&id=3fe04c0e&scoped=true", function () {
      api.rerender('3fe04c0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/property-editor/setDimensional-editor.vue"
export default component.exports